import { type QueryClient } from "@tanstack/react-query";
import { useGetSearchAgentsQueryOptions } from "~/api/generated/agents/agents";
import { type AgentsResponse } from "~/api/generated/model";
import { sanitizeAgents } from "~/api/shared/agent-sanitizer";

const AGENTS_STALE_TIME = 3_600_000;

const selectAgents = ({ searchAgents }: AgentsResponse) =>
  sanitizeAgents(searchAgents);

export const agentsQueries = {
  all: () =>
    useGetSearchAgentsQueryOptions({
      query: {
        staleTime: AGENTS_STALE_TIME,
        retry: 0,
        select: selectAgents,
      },
    }),
  newMatchTotal: (enabled: boolean) =>
    useGetSearchAgentsQueryOptions({
      query: {
        staleTime: AGENTS_STALE_TIME,
        retry: 0,
        enabled,
        select: ({ searchAgents }) =>
          searchAgents.reduce(
            (total, { newMatchCount }) => total + newMatchCount,
            0,
          ),
      },
    }),
};

/**
 * `select` only runs for query observers, so a route loader has to sanitise the
 * cached response itself.
 */
export const ensureAgents = async (queryClient: QueryClient) =>
  selectAgents(await queryClient.ensureQueryData(agentsQueries.all()));
